<template>
  <div class="game">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page fiche-jeu">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">
          <title-page attrpage="Mini jeux" baseline="À toi de jouer !">Découverte</title-page>
          <p>Le premier chargement peut prendre 1 à 2 minutes en fonction de votre connexion</p>
          <div v-if="$isDesktop()" class="box-game">
            <div class="content-game">
              <godot-game
                v-bind="gameInfos"
                @game_finished="endGame"
              />
            </div>
          </div>
          <div v-else>
            <div class="bt-game-mobile chimio">
              <bouton href="/games/decouverte/index.html">Accéder au jeu</bouton>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton.vue'
  import ItemFiche from '@/components/ItemFiche'
  import GodotGame from '@/components/GodotGame'

  import splashFLE from '@/assets/images/games/splash/splash-fle.jpg'
  import splashGame from '@/assets/images/games/splash/splash-decouverte.jpg'
  import FichesDB from '@/datas/fiches'

  export default {
    props: ['gameId'],
    components: { TitlePage, Bouton, ItemFiche, GodotGame },
    data () {
      const me = this.$store.state.me
      const playerInfos = {
        gender: (me.gender === 'H' ? 'boy' : 'girl'),
        playerName: `${me.first_name} ${me.last_name}`,
      }
      return {
        gameInfos: {
          pck: 'jeu-decouverte',
          engineVersion: 'full-3.2.1',
          splashStack: [
            {
              outerBarColor: '#01b1c8',
              innerBarColor: '#e43516',
              backgroundColor: '#FFF',
              duration: 2000,
              splashUrl: splashFLE
            },
            {
              outerBarColor: '#466C91',
              innerBarColor: '#5FABE3',
              backgroundColor: '#000',
              duration: 2000,
              splashUrl: splashGame
            },
          ],
          playerInfos
        },
        fichesIds: [],
        fiches: []
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.me
      }
    },
    async mounted () {
      const fichesDB = await FichesDB();
      this.fiches =  this.fichesIds.map((fid) => fichesDB.find(f => f.id === fid) )
    },
    methods: {
      endGame() {
        if (this.currentUser.account_type === 'child') {
          this.$store.dispatch('playGame', this.gameId)
        }
      }
    }
  }
</script>
